import { CategoryEnum, ProductType } from '@/@types';
import { CDN } from './constants';

export const CDNImage = (src: string) => {
  if (!src) {
    return undefined;
  }
  if (src.startsWith('/')) {
    return CDN + src;
  }
  // weird cases where the url image is something like "https://cdn.peoople.apphttps://lh3.googleusercontent.com/a/ACg8ocKIPco2eYq...
  if (src.startsWith('https://cdn.peoople.appht')) {
    return src.replace('https://cdn.peoople.appht', 'ht');
  }
  return src;
};

export const isProductOfType = <T extends CategoryEnum>(product: ProductType, types: T[]): product is ProductType & { type: T } => {
  return types.includes(product.category?.name as T);
};
